import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Users, Briefcase, FileText, UserPlus } from "lucide-react";
import { CommandDialog, CommandInput, CommandList, CommandEmpty, CommandGroup, CommandItem } from "@/components/ui/command";
import { api } from "@/lib/api";

const ICON = { client: Users, matter: Briefcase, invoice: FileText, lead: UserPlus };

export function GlobalSearch({ open, onOpenChange }) {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const nav = useNavigate();
  useEffect(() => {
    if (!open) { setQ(""); setResults([]); return; }
    if (q.trim().length < 2) { setResults([]); return; }
    const t = setTimeout(() => api.get("/search", { params: { q } }).then((r) => setResults(r.data.results)).catch(() => {}), 250);
    return () => clearTimeout(t);
  }, [q, open]);
  const groups = ["client", "matter", "invoice", "lead"].map((t) => [t, results.filter((r) => r.type === t)]).filter(([, r]) => r.length);
  return (
    <CommandDialog open={open} onOpenChange={onOpenChange} shouldFilter={false} label="Global search">
      <CommandInput placeholder="Search clients, matters, invoices, leads… (Cmd/Ctrl + K)" value={q} onValueChange={setQ} data-testid="global-search-input" />
      <CommandList className="max-h-96" data-testid="global-search-results">
        <CommandEmpty>{q.trim().length < 2 ? "Type at least 2 characters" : "No results found."}</CommandEmpty>
        {groups.map(([type, items]) => (
          <CommandGroup key={type} heading={`${type.charAt(0).toUpperCase()}${type.slice(1)}s`}>
            {items.map((r) => { const Icon = ICON[r.type]; return (
              <CommandItem key={`${r.type}-${r.id}`} value={`${r.type} ${r.title} ${r.subtitle}`} onSelect={() => { onOpenChange(false); nav(r.link); }} data-testid={`search-result-${r.type}-${r.id}`} className="cursor-pointer">
                <Icon className="mr-3 text-[var(--brand)]" /><div><p className="text-sm text-slate-100">{r.title}</p><p className="text-xs text-slate-400">{r.subtitle}</p></div>
              </CommandItem>); })}
          </CommandGroup>))}
      </CommandList>
    </CommandDialog>
  );
}
